import {useMemo} from 'react';
import type {Part} from 'schemaDefinition/types';
import {useLocalization} from 'localization';
import {useFormSchemaGlobalScopeContext} from '../../contexts';
import {getFieldRootKeys} from '../functions';
import {getFieldString} from '../functions/getFieldString';

export const useDeleteAllStrings = (
  part: Part,
): {
  label?: string;
  confirm: {
    title?: string;
    okTitle?: string;
    cancelTitle?: string;
  };
} => {
  const localization = useLocalization();
  const {schema} = useFormSchemaGlobalScopeContext();
  return useMemo(() => {
    const rootKeys = getFieldRootKeys(schema.key, false, part.key, part.name);
    // const fie
    return {
      label:
        getFieldString(rootKeys, false, '.deleteAll', localization) ??
        localization.t('general.deleteAll'),
      confirm: {
        title: `${localization.t('general.deleteAll')}?`,
        okTitle: localization.t('general.delete'),
        cancelTitle: localization.t('general.cancel'),
      },
    };
  }, [localization, part.key, part.name, schema.key]);
};
